import axios, { AxiosInstance } from "axios";

export const apiAxios: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

apiAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);
